import "./App.css";
import "@fontsource/open-sans";
import "@fontsource/open-sans/700.css";
import { softScriptTheme } from "styles/theme";
import { Provider } from "react-redux";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import store from "lib/redux";
import { QueryClient, QueryClientProvider } from "react-query";
import Pages from "pages";
import { createStandaloneToast } from "@chakra-ui/toast";

const { ToastContainer } = createStandaloneToast();
export const queryClient = new QueryClient();
const App = () => {
  // Create a client
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={softScriptTheme}>
          <ColorModeScript initialColorMode={softScriptTheme.config.initialColorMode} />
          <ToastContainer />
          <Pages />
        </ChakraProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
